import React from 'react';
import { Quote, Play } from 'lucide-react';

const TestimonialsSection = () => {
  return (
    <section className="relative py-20 px-4 bg-gradient-to-br from-[#F9FAFB] to-white">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-4" style={{ fontFamily: 'Plus Jakarta Sans, Inter, sans-serif' }}>
            Hear from Our Graduates
          </h2>
          <p className="text-lg text-[#4B5563]">
            Real success stories from students who transformed their careers
          </p>
        </div>

        {/* Testimonial Card */}
        <div className="max-w-5xl mx-auto">
          <div 
            className="rounded-[24px] p-8 md:p-12 bg-white border border-[#E5E7EB]"
            style={{ boxShadow: '0 12px 35px rgba(15, 23, 42, 0.12)' }}
          >
            <div className="grid md:grid-cols-2 gap-8 items-center">
              {/* Left - Image */}
              <div className="relative">
                <div className="relative aspect-video rounded-xl overflow-hidden bg-[#1F2933]">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_techpath-hub/artifacts/kioy6hve_Sameer.jpeg" 
                    alt="Sameer Mirza"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Right - Quote */}
              <div>
                <div className="inline-flex p-3 rounded-full bg-[#2563EB]/10 mb-6">
                  <Quote size={32} className="text-[#2563EB]" strokeWidth={1.5} />
                </div>
                <p className="text-xl text-[#0F172A] leading-relaxed mb-6 font-medium">
                  "CareerLift didn't just teach me technical skills – they showed me how to think like a cloud engineer. The hands-on projects and mentor support were game-changing."
                </p>
                <div className="flex items-center gap-4">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_techpath-hub/artifacts/kioy6hve_Sameer.jpeg" 
                    alt="Sameer Mirza"
                    className="w-16 h-16 rounded-full object-cover border-2 border-[#E5E7EB]"
                  />
                  <div>
                    <p className="text-lg font-bold text-[#0F172A]">Sameer Mirza</p>
                    <p className="text-sm text-[#6B7280]">Cloud Engineer at Fleet Partners</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
